import { useMutation, useQuery } from "@tanstack/react-query";
import { Field, Form, Formik, FormikValues } from "formik"
import { useLocation } from "react-router-dom";
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import CustomTitle from "../../components/CustomMiscellaneous/CustomTitle";
import { FileUploader } from "../../components/FileUploader"
import { hasError } from "../../components/FormComponents/utils";
import HorizontalRule from "../../components/HorizontalRule/HorizontalRule";
import { buildEndpoint, genericDelete, genericFileUpload, genericGet, genericPatch, patchWithDataAndId } from "../../services/api.service";
import PublishIcon from '@mui/icons-material/Publish';
import AttachmentIcon from '@mui/icons-material/Attachment';
import DeleteIcon from '@mui/icons-material/Delete';
import toast from "react-hot-toast";
import { useRef } from "react";
import PublicIcon from '@mui/icons-material/Public';
import PublicOffIcon from '@mui/icons-material/PublicOff';
import { PublicOff } from "@mui/icons-material";


export default function ObraAnexos() {

    const location = useLocation();

    const anexosFormRef = useRef<any>();

    const { data: existingAnexos, refetch: refetchAnexos } = useQuery({
        queryKey: [`anexos`],
        queryFn: async () => await genericGet(`${location.pathname}/anexos`),
        onSuccess: (data) => console.log("Anexos: ", data),
    })



    const mutation = useMutation(genericFileUpload(`${location.pathname}/anexos/upload`), {
        onSuccess: (data) => {
            toast.success("Anexos adicionados com sucesso!");
            refetchAnexos();
            anexosFormRef.current.resetForm();
            console.log("Successfull upload!");
        },
        onError: (error) => {
            console.log("Error on upload!")
        }
    })


    const deleteAnexoMutation = useMutation(genericDelete(`${location.pathname}/anexos`), {
        onSuccess: (data) => {
            console.log("Delete successfull");
            toast.success("Anexo eliminado com sucesso!")

            refetchAnexos();
        },
    })

    const changeFileAccessMutation = useMutation(patchWithDataAndId(`${location.pathname}/anexos`), {
        onSuccess: (data) => {
            toast.success("Acesso a anexo alterado com sucesso!")
            refetchAnexos();

        }, onError: (error) => {
            toast.error("Erro ao alterar acesso a anexo!")
        }
    })

    const handleFileAccessChange = (anexo: any) => {
        changeFileAccessMutation.mutate({data: {isPublic: !anexo.isPublic}, id: anexo.id});
    }


    const formInitialValues = {
        anexos: []
    }


    return (

        <div>
            <div className="px-4">
                <div className="flex items-center px-5 justify-between pr-20">
                    <CustomTitle text={"Anexos"} />
                </div>
                <HorizontalRule />
            </div>
            <div className="pl-6 pt-2">
                {existingAnexos?.map((anexo: any, idx: number) => {
                    return (
                        <div key={idx} className={`w-1/2 flex justify-between p-2 m-1 border border-zinc-300 rounded-md ${anexo.isPublic ? '' : ''}`}>
                            <div className="w-fit p-1 hover:underline">
                                <a href={buildEndpoint(`${location.pathname}/anexos/download/${anexo.id}`)} target='__blank'>
                                     <span className="font-bold">{anexo.name}</span> ({anexo.isPublic ? 'Público' : 'Privado'})
                                </a>
                            </div>
                            <div className="flex items-center">
                                <div onClick={() => handleFileAccessChange(anexo)} className="border border-zinc-300 bg-zinc-300 rounded-md p-1 mr-2 hover:bg-zinc-100 cursor-pointer">
                                    
                                    {anexo.isPublic ? <div><PublicOff/> Tornar Privado</div> : <div><PublicIcon/> Tornar Público</div>}
                                </div>
                                <div className="text-rodrimaq-red-light cursor-pointer" onClick={() => deleteAnexoMutation.mutate(anexo.id)}>
                                    <DeleteIcon />
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
            <div className="p-6">
                <Formik

                    initialValues={formInitialValues}
                    // mutation.mutate(({ ...values }))
                    validateOnChange={false}
                    onSubmit={async (values: FormikValues) => {
                        const documentToSave = new FormData();
                        values.anexos.map((dt: File) => {
                            documentToSave.append('anexos', dt);
                        })
                        mutation.mutate(documentToSave);
                    }}
                    innerRef={anexosFormRef}
                >
                    {(props) => {
                        const { values, errors, touched, handleChange, setFieldValue } = props;
                        return (
                            <Form>
                                <Field
                                    className={"w-1/6"}
                                    name={`anexos`}
                                    component={FileUploader}
                                    title={"Anexos"}
                                    type={"number"}
                                    size="small"
                                    icon={<AttachmentIcon style={{ fontSize: '2.5em' }} />}
                                    error={hasError({ errors, touched, name: `anexos` as any })}
                                    variant={'outlined'}
                                    label={'Anexos'} />

                                <div className="flex justify-end mt-3 mr-2">
                                    <CustomButtonSimple type="submit" text={"Submeter"} Icon={<PublishIcon />} />
                                </div>
                            </Form>
                        )
                    }}



                </Formik>
            </div>
        </div>


    )



}